// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-order_wrapper__644\\+W {
  width: 100%;
}
  
.form-order_tableRow__aLuzX {
  margin: unset;
  padding: unset;
}

.form-order_filters__hAOeK {
  margin: 5px 0;
}`, "",{"version":3,"sources":["webpack://./src/components/wttp/questionnnaires/form-order/index.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".wrapper {\n  width: 100%;\n}\n  \n.tableRow {\n  margin: unset;\n  padding: unset;\n}\n\n.filters {\n  margin: 5px 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `form-order_wrapper__644+W`,
	"tableRow": `form-order_tableRow__aLuzX`,
	"filters": `form-order_filters__hAOeK`
};
export default ___CSS_LOADER_EXPORT___;
